/* =========================================
   KYRA GA4 EVENTS — FULL CUSTOM CLEAN
========================================= */

(function () {
  'use strict';

  function hasGtag() {
    return typeof window.gtag === 'function';
  }

  function sendGa4Event(eventName, payload) {
    if (!eventName) return;

    payload = payload || {};
    payload.debug_mode = true; // TEMP TEST

    if (hasGtag()) {
      window.gtag('event', eventName, payload);
      console.log('KYRA GA4 event sent:', eventName, payload);
    }
  }

  function waitForGtag(callback) {
    if (hasGtag()) {
      callback();
      return;
    }

    setTimeout(function () {
      waitForGtag(callback);
    }, 300);
  }

  /* PAGE VIEW */
  function sendPageView() {
    if (window.__kyraPageViewSent === true) return;

    waitForGtag(function () {
      if (window.__kyraPageViewSent === true) return;
      window.__kyraPageViewSent = true;

      sendGa4Event('page_view', {
        page_title: document.title,
        page_location: window.location.href,
        page_path: window.location.pathname
      });
    });
  }

  /* VIEW ITEM */
  function sendViewItem() {
    const dataEl = document.getElementById('DrGa4ProductData');
    if (!dataEl) return;

    if (window.__kyraViewItemSent === true) return;

    waitForGtag(function () {
      if (window.__kyraViewItemSent === true) return;

      try {
        const productData = JSON.parse(dataEl.textContent);

        window.__kyraViewItemSent = true;

        sendGa4Event('view_item', {
          currency: 'EUR',
          value: productData.price || 0,
          items: [productData]
        });
      } catch (error) {
        console.error('KYRA GA4 view_item error:', error);
      }
    });
  }

  /* ADD TO CART */
  document.addEventListener('dr:add_to_cart', function (event) {
    const payload = event.detail;
    if (!payload) return;

    const item = payload.items && payload.items[0];

    const eventKey = [
      item && item.item_id,
      item && item.item_variant,
      item && item.quantity,
      payload.value
    ].join('|');

    const now = Date.now();

    if (
      window.__kyraLastAddToCartKey === eventKey &&
      window.__kyraLastAddToCartTime &&
      now - window.__kyraLastAddToCartTime < 1500
    ) {
      console.warn('KYRA GA4 add_to_cart skipped duplicate');
      return;
    }

    window.__kyraLastAddToCartKey = eventKey;
    window.__kyraLastAddToCartTime = now;

    sendGa4Event('add_to_cart', payload);
  });

  /* VIEW CART */
  document.addEventListener('dr:view_cart', function (event) {
    const now = Date.now();

    if (
      window.__kyraLastViewCartTime &&
      now - window.__kyraLastViewCartTime < 1500
    ) {
      console.warn('KYRA GA4 view_cart skipped duplicate');
      return;
    }

    window.__kyraLastViewCartTime = now;

    const payload = event.detail || {
      currency: 'EUR'
    };

    sendGa4Event('view_cart', payload);
  });

  /* BEGIN CHECKOUT */
  document.addEventListener('click', function (event) {
    const checkoutBtn = event.target.closest(
      '[data-dr-checkout], a[href="/checkout"], form[action="/checkout"] button[type="submit"], button[name="checkout"], .dr-cart-drawer__checkout'
    );

    if (!checkoutBtn) return;

    if (window.__kyraBeginCheckoutSent === true) return;
    window.__kyraBeginCheckoutSent = true;

    sendGa4Event('begin_checkout', {
      currency: 'EUR'
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      sendPageView();
      sendViewItem();
    }, { once: true });
  } else {
    sendPageView();
    sendViewItem();
  }
})();